import { createCanBoundTo } from '@casl/react';
import ability from '../utils/ability';

export default createCanBoundTo(ability);



// WEBPACK FOOTER //
// ./src/components/Can.js